module.exports = __webpack_public_path__ + "img/pink_mannequin_1.1e0e042e.png";